/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router' 
import ActualizarCorreo from '@/components/actualizar-correo' 
import Unauthorized from '@/components/Unauthorized'
import auth from '../app/auth'
import LogoutSuccess from '@/components/LogoutSuccess' 
import ErrorComponent from '@/components/Error'
import { is_auth, user_registro } from './../middleware' 

Vue.use(Router)

 

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
        path: '/actualizar-correo',
        name: 'actualizarCorreo',
        beforeEnter: user_registro, 
        component: ActualizarCorreo
    }, 
    {
        path: '/unauthorized',
        name: 'Unauthorized',  
        component: Unauthorized
    }, 
    {
        path: '/', component: LogoutSuccess,  async beforeEnter(to, from, next){ 
            next();
        }
  
    },
    {
        path: '/login', beforeEnter(to, from, next){ auth.auth.getSession(); }
    },
    {
        path: '/oauth2', beforeEnter(to, from, next){
            var currUrl = window.location.href; 
            
            auth.auth.parseCognitoWebResponse(currUrl); 
        }
    },
    {
        path: '/logout', component: LogoutSuccess,  beforeEnter(to, from, next){ 
            next();
        }

    },
    {
        path: '/auth/login', component: LogoutSuccess,  beforeEnter(to, from, next){
            next();
        }

    },
    {
        path: '/error', component: ErrorComponent
    }
  ]
})